export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix5-1c979bcd42dc6eaf1af8f6661efe01ff.png";